import { OccConfig } from '@spartacus/core';

export const defaultOccLiteratureContentConfig: OccConfig = {
  backend: {
    occ: {
      endpoints: {
        literatureSearch: 'literatures/search?fields=literatures(DEFAULT),pagination(DEFAULT)',
      },
    } as any,
  },
};
